import { JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { ResponcePage } from 'projects/core/src/lib/misc/data/responce-page';
import { Order } from './order';

@JsonObject('OrdersResponcePage')
export class OrdersResponcePage extends ResponcePage {

	@JsonProperty([Order], 'content')
	content: Order[];
}